<template>
    <div class="header">
        <div class="report-header w-100 d-flex justify-space-between position-relative mb-3">
            <div style="width: 120px;">
                <img width="120" :src="companyStore.getCompanyCompanyLogo" alt="" />
            </div>
            <div class="pt-4 mb-3">
                <div class="text-center">
                    <p class="h3 text-nowrap font-weight-bold text-uppercase">{{companyStore.getCompanyCompanyName}}</p>
                    <p class="h3 font-weight-normal text-nowrap">
                        <span class="text-moul text-primary">{{data.title}}</span>
                    </p>
                    <p class="mb-3" v-if="data.from_date==''">--------------------</p>
                    <p class="mb-3 h5" v-else>{{data.from_date}} ~ {{data.to_date}}</p>
                </div>
            </div>
            <v-btn prepend-icon="mdi-file-export" color="blue" @click="ExcelReport(tableId)">Export</v-btn>
        </div>
    </div>
</template>

<script>
    import { useCompanyStore } from '@/stores/companyStore';
    export default {
        props: ['data', 'tableId'],
        data() {
            return {
                print_date: '',
                store: '',
            }
        },
        setup() {
            const companyStore = useCompanyStore();
            return { companyStore }
        },
        methods: {
            ExcelReport(id) {
                var table = document.getElementById(id);
                var tableHTML = table.outerHTML;
                var fileName = id.replace(' ', '-') + '.xls';

                // Add a title to the HTML content
                var title = this.data.title;

                // Get current date in a readable format
                var currentDate = `${this.data.from_date} ~ ${this.data.to_date}`

                // HTML for centered title and date under it
                var headerHTML = `<div style="text-align: center;"><h2>${title}</h2><p>${currentDate}</p></div>`;

                // Add the header to the table content
                tableHTML = headerHTML + tableHTML;

                // Add border to the table and set header background color
                tableHTML = tableHTML.replace(/<table/g, '<table border="1"');
                tableHTML = tableHTML.replace(/<thead>/g, '<thead style="background-color: orange; color: white;">');

                if (window.navigator.msSaveOrOpenBlob) {
                    // If Internet Explorer
                    var blob = new Blob(['\ufeff', tableHTML], { type: 'application/vnd.ms-excel' });
                    window.navigator.msSaveOrOpenBlob(blob, fileName);
                } else {
                    // For other browsers
                    var a = document.createElement('a');
                    var blob = new Blob(['\ufeff', tableHTML], { type: 'application/vnd.ms-excel;charset=utf-8' });
                    var url = URL.createObjectURL(blob);

                    a.href = url;
                    a.setAttribute('download', fileName);
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);

                    // Release the ObjectURL to free resources
                    URL.revokeObjectURL(url);
                }
            }

        }
    }
</script>
